import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Col, Row, Divider, Button } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'
import TiposDeDocumentoSunatConstant from 'constants/tiposDeDocumentoSunat'

import * as GuiasCompraService from 'services/guiasCompra.service'

import * as FormGroups from './formGroups'
import * as Sections from './sections'

import { ValidationSchema } from '../../_shared/validation'

const actualizarFila = (current, { cantidad, ...restPayload }) => {
  current = {
    ...current,
    ...restPayload,
    cantidad
  }

  return current
}

const commonReducer = (state, action) => {
  switch (action.type) {
    case 'agregar': {
      let newState = state
        .map(val => ({
          ...val,
          __filaActiva: false,
          __focusCantidad: false,
          esFilaBusqueda: false
        }))
        .filter(x => x._idProductoPresentacion)

      let { nuevaFila, viaCodBar, ...payload } = action.payload

      return [
        ...newState,
        {
          ...payload,
          __filaActiva: !viaCodBar,
          __focusCantidad: !viaCodBar,
          _idFila: Math.round(new Date() / 1000),
          cantidad: ''
        },
        {
          __filaActiva: viaCodBar,
          esFilaBusqueda: true,
          _idFila: `${Math.round(new Date() / 1000)}-G`
        }
      ]
    }
    case 'actualizar': {
      const { saltarFila, ...nuevoPayload } = action.payload
      return state.map(val => {
        if (val.esFilaBusqueda) {
          val.__filaActiva = saltarFila
        } else {
          if (val._idFila === nuevoPayload._idFila) {
            val = actualizarFila(val, nuevoPayload)
          }
          val.__filaActiva = !saltarFila
        }
        return val
      })
    }
    case 'eliminar':
      return state.filter(val => val._idFila !== action.payload._idFila)
    default:
      return state
  }
}

const MainForm = ({ history, guiaInfo }) => {
  const __zariContext = React.useContext(ZariContext)

  const [detalles, detallesDispatcher] = React.useReducer(
    commonReducer,
    guiaInfo.detalles,
    initialState => {
      let output = []

      if (initialState) {
        output = initialState.map((x, k) => ({
          ...x,
          _idFila: k
        }))
      }

      output.push({
        esFilaBusqueda: true,
        _idFila: Math.round(new Date() / 1000)
      })

      return output
    }
  )

  const mainFormikRef = React.useRef({})

  const formInitialValues = React.useMemo(
    () => ({
      _idSocio: guiaInfo._idSocio || '',
      comentario: guiaInfo.comentario || '',
      serieDocumento: guiaInfo.serieDocumento || '',
      numeroDocumento: guiaInfo.numeroDocumento || '',
      tipoDocumento: guiaInfo.tipoDocumento || TiposDeDocumentoSunatConstant.OTROS,
      codigoSocio: guiaInfo.codigoSocio || '',
      documentoSocio: guiaInfo.documentoSocio || '',
      tipoDocumentoSocio: guiaInfo.tipoDocumentoSocio || '',
      nombreSocio: guiaInfo.nombreSocio || '',
      fechaEmision: guiaInfo.fechaEmision || '',
      fechaAlmacenamiento: guiaInfo.fechaAlmacenamiento || ''
    }),
    [guiaInfo]
  )

  const submitHandler = (data, { setSubmitting }) => {
    const detallesNormalizados = detalles
      .filter(x => !x.esFilaBusqueda)
      .map(x => {
        return {
          _id: x._id,
          _idProductoPresentacion: x._idProductoPresentacion,
          cantidad: parseFloat(x.cantidad)
        }
      })

    GuiasCompraService.actualizarGuia(guiaInfo._id, {
      ...data,
      detalles: detallesNormalizados
    })
      .then(() => {
        __zariContext.snack('success', 'El registro se ha actualizado.')
        history.push(`/${CodigosTransaccionesConstant.COMPRASINGRESOGUIA_LISTA}`)
      })
      .catch(({ data: { error } }) => {
        __zariContext.snack('error', error)
        setSubmitting(false)
      })
  }

  return (
    <>
      <Row>
        <Col md={12}>
          <Formik
            initialValues={formInitialValues}
            onSubmit={submitHandler}
            innerRef={mainFormikRef}
            validationSchema={ValidationSchema}
          >
            {({ errors, isSubmitting, setValues, touched, values, handleChange, handleSubmit }) => (
              <>
                <Form>
                  <Row>
                    <Col md={5}>
                      <FormGroups.SocioFormGroup values={values} />
                      <FormGroups.NombreSocioFormGroup iValue={values.nombreSocio} />
                    </Col>
                    <Col md={3}>
                      <FormGroups.TipoDocumentoFormGroup
                        fIsSubmitting={isSubmitting}
                        iError={errors.tipoDocumento}
                        iTouched={touched.tipoDocumento}
                      />
                      <FormGroups.SerieNumeroFormGroup fIsSubmitting={isSubmitting} />
                    </Col>
                    <Col md={3}>
                      <FormGroups.FechaEmisionFormGroup
                        handleChange={handleChange}
                        values={values}
                        setValues={setValues}
                        fIsSubmitting={isSubmitting}
                        iError={errors.fechaEmision}
                        iTouched={touched.fechaEmision}
                      />
                      <FormGroups.FechaAlmacenamientoFormGroup
                        fIsSubmitting={isSubmitting}
                        iError={errors.fechaAlmacenamiento}
                        iTouched={touched.fechaAlmacenamiento}
                      />
                    </Col>
                  </Row>
                  <Divider />
                  <Sections.DetallesSection detalles={detalles} dispatch={detallesDispatcher} />
                  {/* <Divider />
                  <Row className='mt-2'>
                    <Col md={6}>
                      <FormGroups.ComentarioFormGroup
                        iError={errors.comentario}
                        iTouched={touched.comentario}
                        fIsSubmitting={isSubmitting}
                      />
                    </Col>
                  </Row> */}
                  <Divider />
                  <Row>
                    <Col md={12} className='text-right'>
                      {/* <Button color='secondary'>Cancelar</Button> */}
                      <Button disabled={isSubmitting} className='ml-2' onClick={handleSubmit}>
                        Actualizar
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </>
            )}
          </Formik>
        </Col>
      </Row>
    </>
  )
}

export default MainForm
